<template>
  <main class="nd-auth-page">
    <section class="nd-auth-shell">
      <div class="nd-auth-visual">
        <div class="nd-auth-brand">
          <span class="nd-auth-brand__mark">
            <img src="@/assets/images/newdental-logo.svg" alt="ND" />
          </span>
          <span>NewDental</span>
        </div>
        <img
          class="nd-auth-illustration"
          src="@/assets/images/login-dental-hero.webp"
          alt="Ambiente odontológico moderno"
        />
      </div>

      <aside class="nd-auth-card">
        <div class="nd-auth-card__brand">
          <span class="nd-auth-card__mark">
            <img src="@/assets/images/newdental-logo.svg" alt="ND" />
          </span>
          <strong>NewDental</strong>
        </div>

        <h1 class="title-login">{{ isRegisterMode ? "Criar acesso" : "Acesso Administrativo" }}</h1>
        <p class="nd-auth-subtitle">
          {{ isRegisterMode ? "Preencha os dados iniciais para solicitar o acesso da clínica." : "Informe suas credenciais para acessar a gestão da clínica." }}
        </p>

        <v-form
          v-if="!isRegisterMode"
          ref="form"
          v-model="loginForm.validForm"
          lazy-validation
          class="nd-auth-form"
          @submit.prevent="login"
        >
          <v-text-field
            placeholder="admin@clinica.com.br"
            ref="username"
            class="nd-auth-field"
            solo
            flat
            :rules="[$rules.required]"
            v-model="loginForm.user.email" hide-details="auto"
            prepend-inner-icon="mdi-account-outline"
          ></v-text-field>

          <v-text-field
            class="nd-auth-field"
            solo
            flat
            placeholder="Senha"
            :append-icon="loginForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            required
            :rules="[$rules.required]"
            :type="loginForm.showPassword ? 'text' : 'password'"
            v-model="loginForm.user.password"
            @click:append="loginForm.showPassword = !loginForm.showPassword" hide-details="auto"
            id="password"
            prepend-inner-icon="mdi-lock-outline"
          ></v-text-field>

          <v-btn
            block
            large
            color="primary"
            elevation="0"
            class="nd-auth-submit"
            :loading="loginForm.loading"
            type="submit"
          >
            Entrar
          </v-btn>
        </v-form>

        <v-form
          v-else
          ref="registerForm"
          v-model="registerForm.validForm"
          lazy-validation
          class="nd-auth-form"
          @submit.prevent="requestAccess"
        >
          <v-text-field
            placeholder="Nome da clínica"
            class="nd-auth-field"
            solo
            flat
            v-model="registerForm.data.company" hide-details="auto"
            prepend-inner-icon="mdi-domain"
          ></v-text-field>

          <v-text-field
            placeholder="Responsável"
            class="nd-auth-field"
            solo
            flat
            v-model="registerForm.data.name" hide-details="auto"
            prepend-inner-icon="mdi-account-outline"
          ></v-text-field>

          <v-text-field
            placeholder="E-mail"
            class="nd-auth-field"
            solo
            flat
            v-model="registerForm.data.email" hide-details="auto"
            prepend-inner-icon="mdi-email-outline"
          ></v-text-field>

          <v-btn
            block
            large
            color="primary"
            elevation="0"
            class="nd-auth-submit"
            :loading="registerForm.loading"
            type="submit"
          >
            Solicitar acesso
          </v-btn>
        </v-form>

        <button v-if="!isRegisterMode" class="btn-forgot-password" type="button" @click="forgotPassword">
          Esqueci minha senha
        </button>

        <div class="nd-auth-divider">
          <span></span>
          <small>ou</small>
          <span></span>
        </div>

        <button class="nd-auth-secondary" type="button" @click="toggleAuthMode">
          {{ isRegisterMode ? "Já tenho acesso" : "Solicitar acesso da clínica" }}
        </button>
      </aside>
    </section>
  </main>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../router";

function decodeJwtPayload(token) {
  const payload = token.split(".")[1];
  if (!payload) throw new Error("Token inválido");

  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
  const decoded = decodeURIComponent(
    atob(padded)
      .split("")
      .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
      .join("")
  );

  return JSON.parse(decoded);
}

export default {
  name: "Login",

  data: () => ({
    page: {
      slogan: null,
    },
    email: "",
    password: "",
    loading: false,
    valid: true,
    show: false,
    rules: {
      email: [
        (v) => !!v || "O usuário é obrigatório",
        // (v) =>
        //   (v && v.length <= 25) ||
        //   "O usuário deve ter menos de 10 caracteres",
      ],
      password: [(v) => !!v || "A senha é obrigatória"],
    },
    loginForm: {
      validForm: true,
      showPassword: false,
      loading: false,
      user: {},
    },
    authMode: "login",
    registerForm: {
      validForm: true,
      loading: false,
      data: {
        company: "",
        name: "",
        email: "",
      },
    },
  }),

  computed: {
    isRegisterMode() {
      return this.authMode === "register";
    },
  },

  mounted() {
    if (this.$route.query.email) {
      this.loginForm.user.email = this.$route.query.email;
    }
  },

  methods: {
    empty() {
      return (
        !this.$data.loginForm.user.email || !this.$data.loginForm.user.password
      );
    },
    async login() {
      if (!this.$refs.form.validate()) return;

      const data = {
        username: this.loginForm.user.email,
        password: this.loginForm.user.password,
        type: 2,
      };

      this.$data.loginForm.loading = true;

      try {
        const fetchSession = await axios.post("/sessions", data);
        const tokenData = fetchSession.data.data;
        const accessToken = tokenData.access;

        if (!accessToken) throw new Error();

        const sessionData = {
          ...tokenData,
          session: tokenData.session || tokenData.id,
        };

        localStorage.setItem("token", JSON.stringify(sessionData));

        var dataUser = {
          ...decodeJwtPayload(accessToken),
          id: tokenData.id,
          permissions: tokenData.permissions || [],
        };

        try {
          const meResponse = await axios.get("/me");
          dataUser = {
            ...dataUser,
            ...(meResponse.data?.data || {}),
            permissions: tokenData.permissions || [],
          };
        } catch (error) {
          console.error("Erro ao carregar usuário logado:", error);
        }

        this.$root.user = dataUser;
        localStorage.setItem("user", JSON.stringify(dataUser));

        router.push("/home");
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: "top-right",
          timeout: 5000,
        });
        this.$data.loginForm.user.password = "";
      } finally {
        this.$data.loginForm.loading = false;
      }
    },

    forgotPassword() {
      this.$router.replace("/solicitar-senha");
    },

    toggleAuthMode() {
      this.authMode = this.isRegisterMode ? "login" : "register";
    },

    async requestAccess() {
      const data = this.registerForm.data;
      if (!data.company || !data.name || !data.email) {
        this.$dialog.notify.error("Preencha os dados para solicitar acesso.", {
          position: "top-right",
          timeout: 3500,
        });
        return;
      }

      this.registerForm.loading = true;
      setTimeout(() => {
        this.registerForm.loading = false;
        this.$dialog.notify.info("Solicitação registrada para configuração do acesso.", {
          position: "top-right",
          timeout: 4000,
        });
        this.authMode = "login";
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.nd-auth-page {
  align-items: stretch;
  background:
    radial-gradient(circle at 18% 18%, rgba(160, 77, 194, 0.14), transparent 34%),
    linear-gradient(135deg, #f3eef7 0%, #dfe2df 100%);
  display: flex;
  min-height: 100vh;
  padding: 0;
}

.nd-auth-shell {
  background: #ffffff;
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(360px, 1fr);
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.nd-auth-visual {
  background: linear-gradient(145deg, #f7f0fb 0%, #e9d8f2 50%, #d7dde0 100%);
  min-height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.nd-auth-brand,
.nd-auth-card__brand {
  align-items: center;
  display: flex;
  gap: 10px;
}

.nd-auth-brand {
  color: #111816;
  font-size: 20px;
  font-weight: 800;
  left: 34px;
  position: relative;
  top: 32px;
  z-index: 2;
}

.nd-auth-brand__mark,
.nd-auth-card__mark {
  align-items: center;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.nd-auth-brand__mark img,
.nd-auth-card__mark img {
  display: block;
  height: 34px;
  width: 34px;
}

.nd-auth-illustration {
  height: 100%;
  inset: 0;
  object-fit: cover;
  object-position: center;
  position: absolute;
  width: 100%;
}

.nd-auth-card {
  align-items: center;
  background: #ffffff;
  box-shadow: -18px 0 58px rgba(33, 20, 42, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  padding: 56px clamp(36px, 3.8vw, 68px);
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 3;
}

.nd-auth-card__brand {
  justify-content: center;
  margin-bottom: 34px;
}

.nd-auth-card__brand strong {
  color: #111816;
  font-size: 23px;
  font-weight: 800;
}

.btn-forgot-password {
  background: transparent;
  border: 0;
  color: #7e3aa2;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  margin-top: 18px;
  padding: 0;
}

.title-login {
  color: #151a18;
  font-size: 50px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.02;
  margin: 0;
  max-width: 620px;
}

.nd-auth-subtitle {
  color: #6c746f;
  font-size: 16px;
  line-height: 1.6;
  margin: 18px auto 32px;
  max-width: 460px;
}

.nd-auth-form {
  margin: 0 auto;
  max-width: 500px;
  width: 100%;
}

.nd-auth-form::v-deep .v-input {
  font-size: 15px !important;
  margin-bottom: 14px;
}

.nd-auth-form::v-deep .nd-auth-field .v-input__slot {
  background: #ffffff;
  border: 1px solid #dfe5e0;
  border-radius: 12px;
  box-shadow: 0 10px 26px rgba(33, 20, 42, 0.05);
  min-height: 58px !important;
  padding: 0 18px !important;
  transition:
    background 0.18s ease,
    box-shadow 0.18s ease;
}

.nd-auth-form::v-deep input {
  font-size: 15px !important;
}

.nd-auth-form::v-deep .nd-auth-field input {
  color: #151a18 !important;
  font-weight: 700;
  max-height: none;
  padding: 18px 0 16px;
}

.nd-auth-form::v-deep .nd-auth-field input::placeholder {
  color: #a2aaa6;
  font-weight: 600;
  opacity: 1;
}

.nd-auth-form::v-deep .nd-auth-field .v-input__prepend-inner,
.nd-auth-form::v-deep .nd-auth-field .v-input__append-inner {
  align-self: center;
  margin-top: 0;
}

.nd-auth-form::v-deep .nd-auth-field .v-icon {
  color: #87928c !important;
  font-size: 21px;
}

.nd-auth-form::v-deep .nd-auth-field.v-input--is-focused .v-input__slot {
  border-color: #9b5bd7;
  box-shadow: 0 14px 34px rgba(160, 77, 194, 0.16);
}

.nd-auth-form::v-deep .nd-auth-field.v-input--is-focused .v-icon {
  color: #8f52d1 !important;
}

.nd-auth-form::v-deep .nd-auth-field.error--text .v-input__slot {
  border-color: #d95478 !important;
}

.nd-auth-form::v-deep .nd-auth-field .v-messages {
  color: #d95478;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  margin-top: 5px;
  text-align: left;
}

.nd-auth-submit {
  font-size: 15px !important;
  height: 56px !important;
  margin-top: 18px;
}

.nd-auth-divider {
  align-items: center;
  color: #8a938d;
  display: flex;
  gap: 12px;
  margin: 28px auto 22px;
  max-width: 360px;
  width: 100%;
}

.nd-auth-divider span {
  background: #e6ebe7;
  flex: 1;
  height: 1px;
}

.nd-auth-divider small {
  font-size: 12px;
  font-weight: 600;
}

.nd-auth-secondary {
  background: #f5ecfa;
  border: 1px solid rgba(160, 77, 194, 0.16);
  border-radius: 8px;
  color: #7e3aa2;
  cursor: pointer;
  font-size: 14px;
  font-weight: 800;
  min-height: 48px;
  padding: 0 24px;
}

@media only screen and (max-width: 980px) {
  .nd-auth-shell {
    grid-template-columns: 1fr;
    min-height: 100vh;
  }

  .nd-auth-visual {
    min-height: 40vh;
  }

  .nd-auth-illustration {
    height: 100%;
  }

  .nd-auth-card {
    box-shadow: 0 -18px 48px rgba(33, 20, 42, 0.08);
    min-height: 60vh;
    padding: 34px 24px 38px;
  }

  .nd-auth-card__brand {
    margin-bottom: 28px;
  }

  .title-login {
    font-size: 38px;
  }
}

@media only screen and (max-width: 600px) {
  .nd-auth-visual {
    min-height: 190px;
  }

  .nd-auth-card {
    min-height: calc(100vh - 190px);
    padding: 32px 22px 38px;
  }

  .title-login {
    font-size: 34px;
  }

  .nd-auth-subtitle {
    font-size: 14px;
  }
}
</style>
